import React from 'react';
import { ConfigProvider, Spin, Table } from 'antd';
import frFR from 'antd/locale/fr_FR';
import { displayNumbers } from '../../variables/numbersFunctions';

const ContratListTable = ({
    columns,
    data,
    loading,
    pagination,
    onChange,
    selecting,
    rowSelection,
    ecritures,
    loadingEcritures,
    onExpand,
    footer,
}) => {
    const expandedRowRender = (record) => {
        const police = record.numeroPoliceP;

        if (loadingEcritures[police]) {
            return (
                <div style={{ padding: "16px", textAlign: "center" }}>
                    <Spin size="small" /> Chargement des écritures comptables...
                </div>
            );
        }

        const groupedEcritures = ecritures
            .filter(e => e.ecriture?.numeroPolice === police)
            .reduce((acc, ecriture) => {
                const codeId = ecriture.ecriture.codeId;
                if (!acc[codeId]) acc[codeId] = [];
                acc[codeId].push(ecriture);
                return acc;
            }, {});

        const ecrituresGrouppees = Object.values(groupedEcritures);

        if (ecrituresGrouppees.length === 0) {
            return (
                <p style={{ padding: '20px', textAlign: 'center', color: '#8c8c8c' }}>
                    Aucune écriture trouvée
                </p>
            );
        }

        return ecrituresGrouppees.map((ec, idx) => (
            <div style={{ padding: "20px", backgroundColor: '#fafafa', borderRadius: '8px', marginBottom: '16px' }} key={idx}>
                <p style={{ fontWeight: 600, color: '#242166', marginBottom: '16px', fontSize: '15px' }}>
                    <strong>Écriture comptable : {ec[0]?.ecriture?.libelle}</strong>
                </p>
                <table className="table table-bordered" style={{ width: "100%", marginBottom: "8px", backgroundColor: '#fff', borderRadius: '6px', overflow: 'hidden' }}>
                    <thead style={{ backgroundColor: '#242166' }}>
                        <tr>
                            <th colSpan={2} style={{ color: '#fff', padding: '12px' }}>COMPTES</th>
                            <th style={{ color: '#fff', padding: '12px' }}></th>
                            <th colSpan={2} style={{ color: '#fff', padding: '12px' }}>MONTANT</th>
                        </tr>
                        <tr style={{ backgroundColor: '#2f2a7a' }}>
                            <th style={{ color: '#fff', padding: '10px' }}>DEBIT</th>
                            <th style={{ color: '#fff', padding: '10px' }}>CREDIT</th>
                            <th style={{ color: '#fff', padding: '10px' }}>LIBELLE</th>
                            <th style={{ color: '#fff', padding: '10px' }}>DEBIT</th>
                            <th style={{ color: '#fff', padding: '10px' }}>CREDIT</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ec.map((ecr, indx) => (
                            <tr key={indx} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                <td style={{ padding: '10px' }}>{ecr?.debit ? ecr?.compte?.numeroCompte : ""}</td>
                                <td style={{ padding: '10px' }}>{ecr?.credit ? ecr?.compte?.numeroCompte : ""}</td>
                                <td style={{ padding: '10px' }}>{ecr?.libelle}</td>
                                <td style={{ padding: '10px', fontWeight: 500 }}>{ecr?.debit ? displayNumbers(ecr?.debit) : ""}</td>
                                <td style={{ padding: '10px', fontWeight: 500 }}>{ecr?.credit ? displayNumbers(ecr?.credit) : ""}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p style={{ fontStyle: "italic", color: '#595959', marginTop: '12px', fontSize: '13px' }}>
                    {ec[0]?.ecriture?.libelle}
                </p>
            </div>
        ));
    };

    return (
        <ConfigProvider locale={frFR} theme={{ token: { colorPrimary: '#242166' } }}>
            <Spin spinning={loading}>
                <Table
                    rowSelection={selecting ? rowSelection : null}
                    expandable={{ onExpand, expandedRowRender }}
                    columns={columns}
                    rowKey="codeId"
                    dataSource={data}
                    onChange={onChange}
                    pagination={pagination}
                    footer={footer}
                    style={{ borderRadius: '8px' }}
                />
            </Spin>
        </ConfigProvider>
    );
};

export default ContratListTable;
